module.exports = "<div id=\"feedback\" class=\"default-box {{ showClass }}\" [ngClass]=\"[classes]\" >\n    <i class=\"close\" (click)=\"toggle()\">×</i>\n    <div class=\"container\">\n        {{ content }}\n        <div #template></div>\n    </div>\n</div>\n<div id=\"feedback-layer\" *ngIf=\"showClass === 'scrollIn'\" (click)=\"toggle()\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/feedback/feedback.component.html
// module id = 505
// module chunks = 0